import type { Message } from '../types';
import { chatCopy } from '../../config';

/**
 * #2109 R3-B15: the text a turn renders and exports. A message that carries
 * a `kind` is a client-built system line: the copy pack words it in the
 * reader's language at display time. A kind the pack has no wording for —
 * and every ordinary turn — shows its stored `content`.
 */
export function messageText(message: Pick<Message, 'content' | 'kind' | 'params'>): string {
  if (!message.kind) return message.content;
  return chatCopy().systemMessage(message.kind, message.params) ?? message.content;
}
